import { useAuthStore } from './store';

/* Etap 35 — mirrors the backend's `admin_has_permission` decision (full_access
   short-circuits, otherwise an exact code match) using whatever `permission_codes`
   is currently in the auth store. This is a UI convenience only — the real
   boundary is the backend's `RequirePermission<P>`, which re-checks on every
   request regardless of what this returns. */

const FULL_ACCESS_CODE = 'full_access';

export function hasPermission(codes: string[] | null | undefined, permission: string): boolean {
  if (!codes) return false;
  return codes.includes(FULL_ACCESS_CODE) || codes.includes(permission);
}

/** Reactive: re-evaluates whenever the store's `user.permission_codes` changes
 *  (e.g. after a live SSE-triggered `/v1/me` re-fetch — see useLivePermissionSync). */
export function usePermission(permission: string): boolean {
  return useAuthStore((s) => hasPermission(s.user?.permission_codes, permission));
}
